var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"supplier-list-item",attrs:{"to":("/super/suppliers/" + (_vm.supplierItem.id))}},[_vm._v(_vm._s(_vm.supplierItem.name))])}
var staticRenderFns = []

export { render, staticRenderFns }